// src/components/Opinie.js
import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
// import orly from '../../img/orly.png'
const opinieArray = [
{
name: "Wojtek",
rating: 5,
text: "Pan Maciej potrafi sprawić, że nawet mój stres topnieje szybciej niż lód w saunie. Polecam każdemu, kto lubi parę i śmiech!"
},
{
name: "Kasia",
rating: 5,
text: "Saunamistrz z poczuciem humoru i ręką do temperatury – wchodzi się jak w kociołek relaksu. Po seansie czuję się jak nowo narodzona."
},
{
name: "Dominik",
rating: 5,
text: "Profesjonalista w saunie i mistrz żartów parowych. Człowiek potrafi wytłumaczyć, kiedy lepiej wyjść, a kiedy zostać i poczuć magiczny gorąc."
},
{
name: "Antek",
rating: 5,
text: "Nie tylko świetnie kontroluje temperaturę, ale też atmosferę. Nawet moja ciocia wyszła z sauny uśmiechnięta i bez czerwonych policzków!"
}
];


const Opinie = () => {
const [selectedOpinie, setSelectedOpinie] = useState([]);

useEffect(() => {
// Losowanie 2 unikalnych opinii
const shuffled = [...opinieArray].sort(() => 0.5 - Math.random());
setSelectedOpinie(shuffled.slice(0, 2));
}, []);

return (
<section className="py-24 px-6 lg:px-20 bg-[#14100d]">
  <div className="max-w-4xl mx-auto">
    
    <h2 className="text-4xl font-serif text-center mb-16 text-[#c6a15b]">
      Opinie klientów
    </h2>

    <div className="space-y-8">
      {selectedOpinie.map((opinia, index) => (
        <div
          key={index}
          className="border border-[#2a1f17] rounded-2xl p-8 bg-[#0f0a07] shadow-lg"
        >
          <div className="flex items-center mb-4">
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                className={
                  i < opinia.rating
                    ? "text-[#c6a15b]"
                    : "text-[#2a1f17]"
                }
              />
            ))}
          </div>

          <p className="italic mb-4 text-lg leading-relaxed text-[#f5f1ea] opacity-90">
            "{opinia.text}"
          </p>

          <p className="font-semibold text-right text-[#c6a15b]">
            — {opinia.name}
          </p>
        </div>
      ))}
    </div>

    <div className="mt-12 text-center">
      <a
        href="https://maps.app.goo.gl/hj73Zn2uUsc6nVUM6"
        target="_blank"
        rel="noopener noreferrer"
        className="border border-[#c6a15b] px-6 py-3 rounded-lg text-[#c6a15b] hover:bg-[#c6a15b] hover:text-[#1a140f] transition"
      >
        Zobacz więcej opinii (Google Maps)
      </a>
    </div>

  </div>
</section>

);
};

export default Opinie;
